import * as React from 'react';

import { Input } from '@longline/aqua-ui/inputs/Input';

import { SearchFilter } from '../ui/SearchFilter';

interface ITextFilter {
  q?: string;
}

interface IProps {
  filter: ITextFilter;
  onChange: (filter: ITextFilter) => void;
  placeholder?: string;
}

const hasFilter = (filter: ITextFilter) => 
      (filter.q != null && filter.q != "");

const TextFilter = (props: IProps) => {
      
  const handleChange = (name: string, value: any) => {
    const newFilter: ITextFilter = {...props.filter};
    (newFilter as any)[name] = value;
    props.onChange(newFilter);
  }  

  return (
    <SearchFilter>
      <SearchFilter.Chips>
      </SearchFilter.Chips>
      <SearchFilter.Controls>
        <Input fluid clearable value={props.filter.q} type="text" placeholder={props.placeholder ?? "Filter by name"} autocomplete="off" onChange={(value) => handleChange("q", value)}/>
      </SearchFilter.Controls>
    </SearchFilter>
  )
}

export { TextFilter, ITextFilter, hasFilter }
